import { useQueryClient } from "@tanstack/react-query";
import PeopleEditor, { type PersonRow } from "@/components/PeopleEditor";
import { saveCustomerContacts, useAuthToken, useCustomerContacts } from "@/lib/hooks";

export default function ContactsEditor({ customerId }: { customerId: string }) {
  const token = useAuthToken();
  const queryClient = useQueryClient();
  const { data, isLoading } = useCustomerContacts(customerId);

  const people: PersonRow[] = (data?.contacts ?? []).map((c) => ({
    id: c.id,
    name: c.name,
    title: c.title,
    email: c.email,
    phone: c.phone,
  }));

  async function onSave(rows: PersonRow[]) {
    const res = await saveCustomerContacts(
      token,
      customerId,
      rows.map((r) => ({ name: r.name, title: r.title ?? null, email: r.email, phone: r.phone })),
    );
    queryClient.setQueryData(["customer-contacts", customerId], res);
  }

  return (
    <PeopleEditor
      heading="Key hospital contacts"
      people={people}
      isLoading={isLoading}
      onSave={onSave}
      showTitle
      displayLimit={3}
      emptyText="No contacts yet."
      addLabel="Add contacts"
      noteText="The top 3 (in order) show on this page. Blank rows are ignored."
      exportBase={`${data?.customer_name ?? customerId}-contacts`}
    />
  );
}
